import { HttpContextToken } from '@angular/common/http';

/**
 * Le ordena a `InterceptorService` que NO ponga `Content-Type: application/json`
 * en esta petición.
 *
 * Los bodies `FormData` ya se detectan solos (el browser tiene que poner él
 * mismo el `boundary` del multipart), así que este token es para el resto de
 * casos donde el content-type lo decide el llamador.
 *
 * Uso:
 * ```ts
 * this.http.post(url, body, {
 *   context: new HttpContext().set(SKIP_JSON_CONTENT_TYPE, true),
 * });
 * ```
 */
export const SKIP_JSON_CONTENT_TYPE = new HttpContextToken<boolean>(() => false);
